import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFCONUSByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFOConusByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        totalMfdQuantity: '$..TotalMfdQuantity',
        totalMfdPrice: '$..TotalMfdPrice',
        totalPrinterQuantity: '$..TotalPrinterQuantity',
        totalPrinterPrice: '$..TotalPrinterPrice',
        totalScannerQuantity: '$..TotalScannerQuantity',
        totalScannerPrice: '$..TotalScannerPrice',
        totalTonerPaperQuantity: '$..TotalTonerPaperQuantity',
        totalTonerPaperPrice: '$..TotalScannerPrice',
        totalTonerQuantity: '$..TotalTonerQuantity',
        totalTonerPrice: '$..TotalTonerPrice',
        totalPaperTrayQuantity: '$..TotalPaperTrayQuantity',
        totalPaperTrayPrice: '$..TotalPaperTrayPrice',
        totalOrderQuantity: '$..TotalOrderQuantity',
        totalOrderPrice: '$..TotalOrderPrice',
        dateEquipmentReq: '$..DateEquipmentReq',
        hasBaseAccessReq: '$..HasBaseAccessReq',
        baseAccessReqNotes: '$..BaseAccessReqNotes',
        network: '$..Network',
        firstName: '$..POCFirstName',
        lastName: '$..POCLastName',
        email: '$..POCEmail',
        telephone: '$..POCTelephone'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
